module.exports = __webpack_public_path__ + "img/hint-five-eng.7332730e.jpg";